module.exports = __webpack_public_path__ + "files/ffa0dad8938ceaf4e554a2fe84ae281e.png";